import type { ListStorageFileAuditOptions, StorageFileAuditEntry, StorageFileAuditListPage } from '@jarvis/platform-ui';
import { apiFetch, readJson } from './client';

export type { ListStorageFileAuditOptions, StorageFileAuditEntry, StorageFileAuditListPage };

function toQueryString(params: Record<string, string | number | boolean | undefined>): string {
  const parts = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== '')
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`);
  return parts.length === 0 ? '' : `?${parts.join('&')}`;
}

export async function listClientPortalStorageFileAudits(
  opts: ListStorageFileAuditOptions = {}
): Promise<StorageFileAuditListPage> {
  const res = await apiFetch(`/api/admin/client-portal/storage-audit${toQueryString({ ...opts })}`);
  if (!res.ok) throw new Error(`Failed to list client portal file audit events: ${res.status}`);
  return readJson<StorageFileAuditListPage>(res);
}
